<div class="breadcrumb_main_box">
  <ol class="breadcrumb breadcrumb_ol_new">
    <li class="breadcrumb-item" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ol>
</div>
<mat-toolbar>
  <h6 class="show-title">{{pageTitle}}</h6>
  <button *ngIf="addButton" class="more-btn-custom" mat-raised-button (click)="addDevice()">
    <i class="material-icons icon-layout-custom">add_circle</i><span class="m_l_5 mob_hide">Add New</span>
  </button>
  <button *ngIf="showViewButton" class="more-btn-custom" mat-raised-button (click)="viewLicense(pdffile)">
    <i class="material-icons icon-layout-custom">visibility</i><span class="m_l_5 mob_hide">View licence</span>
  </button>
</mat-toolbar>
<div fxLayoutAlign="center center" fxLayout="column" style="padding: 16px; margin-bottom: 100px;">
  <form [formGroup]="uForm" (ngSubmit)="saveDevice()" class="form_outer_box">
    <div class="form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <mat-select placeholder="Select client" formControlName="client_value">
          <mat-option *ngFor="let clients of clientList;let idx = index;" [value]="clients.id"
            (click)="selectedClient(clients.id, clients.company_name)">
            {{clients.company_name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput placeholder="PO Number" type="text" matInput formControlName="po" id="po">
        <!-- <mat-placeholder class="placeholder">PO Number&nbsp;*</mat-placeholder> -->
      </mat-form-field>
    </div>
    <div class="form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput type="number" placeholder="No. of licences" formControlName="number_of_licence" id="number_of_licence">
        <!-- <mat-placeholder class="placeholder">No. of licences</mat-placeholder> -->
      </mat-form-field>
    </div>
    <div class="form_field_outer">
      <mat-form-field class="example-full-width" floatLabel="always">
        <mat-label>PO Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="po_date" id="po_date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div *ngIf="functionType === 'edit'" class="custom_file_upload">
      <div class="uploaded_image" style="margin-bottom: 16px;">
        <input type="file" class="change_img_input" accept="pdf/*" ng2FileSelect [uploader]="uploader"
          (change)="upload($event.target.files)">
      </div>
      <div style="margin-bottom: 16px;" class="progress progress_bar" *ngIf="fileName !==''">
        <div class="progress-bar progress-bar-striped active" role="progressbar" [attr.aria-valuenow]="percentDone"
          aria-valuemin="0" aria-valuemax="100" [ngStyle]="{'width': percentDone + '%'}">
          {{percentDone}}%
        </div>
      </div>
    </div>
    <div class="btn-box text-center m_t_0">
      <button mat-raised-button style="border-radius: 50px;" type="submit"
        [disabled]="!uForm.valid">{{saveButton}}</button>
    </div>
  </form>
</div>